// extracted by mini-css-extract-plugin
export default {"movie":"Youtube_movie__7sd-b"};